export default "__VITE_ASSET__5592bb04__"